import React from 'react'
import { ElevatedCircle } from '../Core/ElevatedCircle'
import { SkywatchDialog } from '../PopUps/SkywatchDialog'
import PostAddIcon from '@material-ui/icons/PostAdd';
import { Controller, useForm } from "react-hook-form";
import { MenuItem, Select, TextField } from '@material-ui/core';
import NewFillButton from '../Core/NewFillButton';
import { DatePicker } from '@material-ui/pickers';
import { FirebaseConfigKey, FirebaseService } from '../../services/FirebaseService';
import SkywatchDropzone from '../Core/SkywatchDropzone';
import FlexView from 'react-flexview/lib';
import DescriptionIcon from '@material-ui/icons/Description';
import PolicyManagementImpersonationApi from '../../api/policmanagement.impersonation.api';
import { awaitWithLoading } from '../../services/utils';
import { EventEmitterService, EventKey } from '../../services/EventEmitterService';


export const ManualEndorsementPopup = ({open, insuranceId, onCancel, ...props}) => {
    const endorsementFileRef = React.useRef()
    const { register, getValues, watch, errors, triggerValidation, setValue, control } = useForm({mode: 'onChange'});
    const onSubmit = async () => {
        let valid = await triggerValidation()

        if(!valid) return

        let res = await awaitWithLoading(PolicyManagementImpersonationApi.submitManualEndorsement(insuranceId, getValues(), endorsementFileRef.current.getFiles()[0]))

        if (res.ok) {
            EventEmitterService.dispatch(EventKey.ShowSuccess, {title: 'Success',
                body: "Manual Endorsement uploaded successfuly",
                onClose: onCancel 
            });
        }
        else{
            EventEmitterService.dispatch(EventKey.ShowError, res)
        }

    }

    return(<SkywatchDialog open={open} insuranceId={insuranceId} closeDialog={onCancel} closeTitle={"Your Policy"} maxWidth={'xs'}      
        circleHeader={<ElevatedCircle> <PostAddIcon className="blue medium-icon" /> </ElevatedCircle>}>

        <div className="text-title blue bold margin-top-basic textcenter margin-bottom-basic">Upload Manual Endorsement</div>

        <TextField className="margin-top-basic" name="endorsement_name" variant="outlined" label="Endorsement Name" inputRef={register({required: true})} fullWidth 
            error={!!errors.endorsement_name} helperText={!!errors.endorsement_name && 'Required'} />

        <TextField className="margin-top-basic margin-bottom-basic" name="endorsement_revision" variant="outlined" label="Endorsement Star Number" inputRef={register({required: true})} fullWidth
            error={!!errors.endorsement_revision} helperText={!!errors.endorsement_revision && 'Required'}  />

            
        <SkywatchDropzone
            ref={endorsementFileRef}
            accept={[".pdf"]}
            placeholder={<FlexView vAlignContent={'center'}>
                <DescriptionIcon className="lightgrayblue margin-right-6" />
                <div className="text-body lightgrayblue"><span className="blue underline">Upload</span> or drag & drop your endorsement file</div>
            </FlexView>} />

        <TextField className="margin-top-basic" name="endorsement_title" variant="outlined" label="Endorsement Title" inputRef={register({required: true})} fullWidth
            error={!!errors.endorsement_title} helperText={!!errors.endorsement_title && 'Required'}  />

        <Controller className="margin-top-basic"
            as={<DatePicker
                    fullWidth
                    openTo="year"
                    views={["year", "month", "date"]}
                    label={'Issued Time'}
                    error={!!errors.issued_time}
                    inputVariant="outlined"
                    helperText={!!errors.issued_time && 'Requierd'}
                    format={FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT)}
                />}
                onChange={date => {
                    setValue('issued_time', new Date(date[0]));
                    return new Date(date[0]) //important to update the controller value after change else state is updated and the controller will not render
                }}
                rules={{required: true}}
                name="issued_time"
                value={watch('issued_time')}
                defaultValue={null}
                control={control}
            />

        <Controller className="margin-top-basic"
                    as={<DatePicker
                            fullWidth
                            openTo="year"
                            views={["year", "month", "date"]}
                            label={'Valid From'}
                            error={!!errors.valid_from}
                            inputVariant="outlined"
                            helperText={!!errors.valid_from && 'Requierd'}
                            format={FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT)}
                        />}
                        onChange={date => {
                            setValue('valid_from', new Date(date[0]));
                            return new Date(date[0]) //important to update the controller value after change else state is updated and the controller will not render
                        }}
                        rules={{required: true}}
                        name="valid_from"
                        value={watch('valid_from')}
                        defaultValue={null}
                        control={control}
                    />  

        <Controller className="margin-top-basic"
                    as={<DatePicker
                            fullWidth
                            openTo="year"
                            views={["year", "month", "date"]}
                            label={'Valid Until'}
                            error={!!errors.valid_until || watch('valid_until') < watch('valid_from')}
                            inputVariant="outlined"
                            helperText={!!errors.valid_until && 'Requierd'}
                            format={FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT)}
                        />}
                        onChange={date => {
                            setValue('valid_until', new Date(date[0]));
                            return new Date(date[0]) //important to update the controller value after change else state is updated and the controller will not render
                        }}
                        rules={{required: true}}
                        name="valid_until"
                        value={watch('valid_until')}
                        defaultValue={null}
                        control={control}
                    />  

        <TextField className="margin-top-basic" name="price" variant="outlined" label="Price" inputRef={register({required: true})} type="number" fullWidth
            error={!!errors.price} helperText={!!errors.price && 'Required'}  />

        <NewFillButton className="margin-top-basic" onClick={onSubmit}>Save</NewFillButton>

    </SkywatchDialog> )
}

